import { Grid } from '@mui/material'
import React, { useContext } from 'react'
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext'
import EmptyState from '../../global/emptyState'; 
import emptyWhatsappCampaignImage from "../../../assets/images/whatsappCampaign/emptyWhatsappCampaignImage.png";
import GlobalButton from '../../utility/globalButton/button';
import IconsColor from '../../utility/iconsColor';
import WorkflowTable from './workflowList';
import WorkflowList from './workflowList';

const WorkflowIndex = () => { 

    const {workflowList, setWorkflowList} = useContext(WorkflowContext) as WorkflowContextPayload;

  return (
    <>
      <Grid item sx={{ width: "100%", padding: "5px 10px 5px 5px" }}>
                <Grid container direction={"column"} gap={"24px"}>
                    {!workflowList ?
                        <> </>
                        :
                        workflowList.length === 0 ?
                            <Grid item sx={{ width: "100%" }}>
                                <EmptyState
                                    height={'calc(100vh - 125px)'}
                                    pageIcon={<img alt="icon" src={emptyWhatsappCampaignImage} style={{ width: "165px", height: "auto" }} />}
                                    pageSubText={"No Chatbot Created Yet"}
                                    primaryActionBtn={<GlobalButton
                                        buttonText={"New Chatbot"}
                                        className='primaryButtonStyle'
                                        sx={{ width: "170px" }}
                                        startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                        onClick={() => { }}
                                    />}
                                />
                            </Grid>
                            :
                            <> 
                                <WorkflowList />
                            </>
                    }
                </Grid>
            </Grid>
    </>
  )
}

export default WorkflowIndex
